function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.813 4.25v14.625M1 15.5l2.813 3.375L6.625 15.5m12.272 7.875h-3.86a.546.546 0 01-.47-.254.457.457 0 01.015-.499l4.336-6.369a.457.457 0 00.016-.498.546.546 0 00-.466-.255h-3.86M14.5 8.75V2.844c0-1.088 1.007-1.969 2.25-1.969S19 1.756 19 2.844V8.75m-4.5-3.937H19",
  stroke: "#000",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgAlphabet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24
  }, props), _ref);
}

export default SvgAlphabet;